import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledIonModal, StyledModalContent} from '../../../components/modal/modal.style';
import {StyledAuditReports} from '../panes/auditReports.style';
import {StyledButton} from '../../../components/button/button.style';
import CloseImage from '../../../assets/images/e-remove.svg';
import {AuditReportPlanned} from '../../../models/auditReport';
import {getShitPeriodReadable} from '../../../services/audit.service';

const MomentRange = require('moment-range');
const Moment = require('moment-timezone');
const moment = MomentRange.extendMoment(Moment);

type PlannedAuditsModalProps = {
    isOpen: boolean;
    plannedAudits: AuditReportPlanned[];
    specificationNumber?: string;
    onSelectPlanned: (audit: AuditReportPlanned) => void;
    onStartNew: () => void;
    onClose: () => void;
};

const PlannedAuditsModal: React.FC<PlannedAuditsModalProps> = (props: PlannedAuditsModalProps) => {
    const {t} = useTranslation();

    const handleClose = () => {
        props.onClose();
    };

    return (
        <StyledIonModal
            isOpen={props.isOpen}
            onDidDismiss={() => handleClose()}
            initialBreakpoint={0.99}
            breakpoints={[0, 0.65, 0.99]}
        >
            <StyledModalContent className="modal-wrap t-p-50 scrollable">
                <img src={CloseImage} className="close" alt="close" onClick={() => handleClose()}/>
                <h1 className="title" style={{textAlign: 'center', width: '100%'}}>
                    {t('auditReport.plannedAudits.foundForSpecification', {specificationNumber: props.specificationNumber})}
                </h1>

                <StyledAuditReports>
                    {props.plannedAudits.map((audit: AuditReportPlanned, i) => (
                        <div key={i} className="order" style={{cursor: 'pointer'}} onClick={() => props.onSelectPlanned(audit)}>
                            <div className="order-number">
                                #{audit.id} {audit.place_of_service?.name}
                            </div>
                            <div className="details">
                                <div className="detail">{t('auditsPlannedTab.dateExecution')}:&nbsp;
                                    <span className="value">{moment(audit.date_execution, moment.ISO_8601).tz('Europe/Warsaw').format('DD.MM.YYYY')}</span>
                                </div>
                                <div className="detail">{t('auditsTab.placeOfService')}:&nbsp;
                                    <span className="value">{audit.place_of_service?.name}</span>
                                </div>
                                {audit.order && (
                                    <div className="detail">{t('auditsTab.order.number')}:&nbsp;
                                        <span className="value">{audit.order?.formatted_number}</span>
                                    </div>
                                )}
                                <div className="detail">{t('auditsTab.type')}:&nbsp;
                                    <span className="value">{audit.type}</span>
                                </div>
                                <div className="detail">{t('auditsTab.shift_period')}:&nbsp;
                                    <span className="value">{getShitPeriodReadable(audit.shift_period)}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </StyledAuditReports>

                <StyledButton onClick={() => props.onStartNew()} style={{marginTop: '24px', marginBottom: '24px'}}>
                    {t('auditReport.plannedAudits.startNew')}
                </StyledButton>
            </StyledModalContent>
        </StyledIonModal>
    );
};

export default PlannedAuditsModal;